export default "__VITE_ASSET__BfNZzj3O__"